module.exports = __webpack_public_path__ + "img/SDG-12-EN-INVERTED.b58181fb.png";